export default "/storefront/client/images/firefox.png";